import { MutationTuple, useMutation } from '@apollo/client';

import {
  LinkTicketingProviderUserToRdTaxCreditContributorMutation,
  LinkTicketingProviderUserToRdTaxCreditContributorMutationVariables,
  LINK_TICKETING_PROVIDER_USER_TO_RD_TAX_CREDIT_CONTRIBUTOR,
} from '@neo.tax/shared';

type UseLinkTicketingProviderUserToRdTaxCreditContributor = MutationTuple<
  LinkTicketingProviderUserToRdTaxCreditContributorMutation,
  LinkTicketingProviderUserToRdTaxCreditContributorMutationVariables
>;

export const useLinkTicketingProviderUserToRdTaxCreditContributor =
  (): UseLinkTicketingProviderUserToRdTaxCreditContributor =>
    useMutation<
      LinkTicketingProviderUserToRdTaxCreditContributorMutation,
      LinkTicketingProviderUserToRdTaxCreditContributorMutationVariables
    >(LINK_TICKETING_PROVIDER_USER_TO_RD_TAX_CREDIT_CONTRIBUTOR, {
      context: {
        successToast: {
          title: 'Accounts successfully linked',
        },
        errorToast: {
          title: 'Error linking accounts',
          description: 'Something unexpected prevented your changes from saving. Please try again.',
        },
      },
    });
